import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "ds-attendance-auto-approved-banner",
  class: "flex flex-col gap-2 rounded-lg border border-sucess bg-green-50 p-3 text-left"
}
const _hoisted_2 = { class: "w-fit rounded bg-sucess px-2 py-[2px] text-[11px] font-bold uppercase leading-4 tracking-wide text-white" }
const _hoisted_3 = { class: "text-sm leading-[18px] text-textPrimary" }
const _hoisted_4 = { class: "mt-1 flex flex-col gap-2 sm:flex-row" }

import { computed } from 'vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { APPROVAL_MODE_LABELS } from '@/constants/ds-attendance-auto-approval.constants'
import type { DSAttendanceApprovalMode } from '@/Network/Types/Responses/DsAttendanceAuditResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceAutoApprovedPanel',
  props: {
    approvalMode: {},
    isApproved: { type: Boolean, default: false },
    lineCount: {},
    canReopen: { type: Boolean, default: false },
    reopening: { type: Boolean, default: false }
  },
  emits: ["showCriteria", "reopen"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * Fase 2 do fluxo de auditoria (spec 2026-09-11, §6) — o estado "Aprovado automaticamente"
 * na tela de auditoria: banner verde com a contagem de plantões que conferiram, "Ver
 * critérios" e "Reabrir para auditoria" (o mesmo `revert-validation` do fluxo manual).
 *
 * `approvalMode` ausente é backend anterior à fase 2: nada é renderizado e a tela segue
 * exatamente como hoje.
 */




const isAutoApproved = computed(() => props.isApproved && props.approvalMode === 'AUTOMATIC')

const bannerText = computed(() => {
  const total = props.lineCount ?? 0
  if (total <= 0) {
    return 'Todos os plantões previstos conferem com a folha dentro da tolerância.'
  }
  const plantoes = total === 1 ? 'plantão previsto confere' : 'plantões previstos conferem'
  return `Todos os ${total} ${plantoes} com a folha dentro da tolerância.`
})

return (_ctx: any,_cache: any) => {
  return (isAutoApproved.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(APPROVAL_MODE_LABELS).AUTOMATIC), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(bannerText.value), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(OutlineButton, {
            text: "Ver critérios",
            "data-testid": "ds-attendance-auto-approved-criteria-button",
            width: "160px",
            height: "36px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('showCriteria')))
          }),
          (_ctx.canReopen)
            ? (_openBlock(), _createBlock(OutlineButton, {
                key: 0,
                text: "Reabrir para auditoria",
                "data-testid": "ds-attendance-auto-approved-reopen-button",
                width: "210px",
                height: "36px",
                disabled: _ctx.reopening,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('reopen')))
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})